import React from 'react'

import Image from '../../imgix-img'
import { connect } from 'react-redux'
import { FsCore } from '@t/fs-core'
import { getComponentById } from '@r/component/component-selectors'
import { Icon, Button } from '../../../atoms'

export interface CardFinderProps {
  name: string
  jsonBody: {
    showCard: boolean
    title: string
    subtitle: string
    stepList: {
      text: string
    }[]
    showEligibilitySlider: boolean
    showTrustPilot: boolean
    url?: string
    buttonText: string
    ctaIcon: boolean
    subCategory?: string
    secondary?: boolean
    cardLogo?: string
  }
  variant: string
  rawName: string
  sys: { id: string }
  trustpilotData: any
}

const CardFinder: React.FC<CardFinderProps> = ({
  jsonBody,
  name,
  variant,
  rawName,
  sys,
  trustpilotData,
}) => {
  const {
    showCard,
    title,
    subtitle,
    stepList,
    showEligibilitySlider,
    showTrustPilot,
    buttonText = 'Get Started',
    ctaIcon = false,
    subCategory,
    url,
    secondary = false,
    cardLogo,
  } = jsonBody

  const ctaUrl =
    url ||
    (subCategory
      ? `/credit-cards/eligibility-checker?productType=${subCategory}`
      : `/credit-cards/eligibility-checker`)

  const addsecondaryModifier = (classname: string): string =>
    secondary ? `${classname} ${classname}--secondary` : classname

  try {
    return (
      <div className={addsecondaryModifier('CardFinderWrapper')}>
        {showCard && (
          <div className='CardFinder__card'>
            <Image
              src={
                cardLogo ||
                'https://img.money.co.uk/t014ej9w3ur1/1j1eejKxrcAOQZQohKkPEj/7ba16370781aaa7a7b3b631a97dcc84e/credit-card.png'
              }
              alt={cardLogo ? 'logo' : 'cardFinder-credit-card'}
              width={188}
              critical={false}
            />
          </div>
        )}
        <div className={addsecondaryModifier('CardFinder')} id={name}>
          <h2
            className={
              showCard
                ? addsecondaryModifier('CardFinder__title--withCard')
                : addsecondaryModifier('CardFinder__title')
            }
          >
            {title}
          </h2>
          <div className={addsecondaryModifier('CardFinder__subtitle')}>{subtitle}</div>
          {showEligibilitySlider && (
            <div className='CardFinder__eligibility_container'>
              <Image
                className='CardFinder__eligibility'
                src='https://img.money.co.uk/t014ej9w3ur1/7m0gmSD1tfr1Bs4iUMkzns/d05b4798cf7c3b021707d1034911fcd5/eligibility-gif-compressed.gif'
                alt='eligibility-animation'
                originalSize={true}
                critical={false}
              />
            </div>
          )}
          <div className='CardFinder__steps'>
            {stepList &&
              stepList.map((step, i) => {
                return (
                  <div key={i} className={addsecondaryModifier('CardFinder__step')}>
                    <div className={addsecondaryModifier('CardFinder__stepNumber')}>{i + 1}</div>
                    <div className='CardFinder__stepText'>{step.text}</div>
                  </div>
                )
              })}
          </div>
          <div className='CardFinder__anchor'>
            <Button
              href={ctaUrl}
              /* eslint-disable camelcase */
              dataClickTracking={{
                component_category: 'platinum-component',
                component_id: sys?.id,
                component_name: 'cardFinder',
                contentful_name: rawName,
                contentful_variant: variant,
                additionalProps: { text: buttonText },
              }}
              variant={secondary ? 'secondary' : 'primary'}
              size='lg'
              withIcon={ctaIcon}
            >
              {buttonText}
            </Button>
          </div>
          {showTrustPilot && trustpilotData && (
            <a
              className='CardFinder__trustpilot'
              target='_blank'
              href={trustpilotData.link}
              rel='noreferrer'
            >
              {/* @ts-ignore */}
              <Icon
                glyph={'trust-pilot-logo-white'}
                color={secondary ? '#000' : '#fff'}
                fill={secondary ? '#000' : '#fff'}
              />
              <Image
                src={`https://images-static.trustpilot.com/api/stars/${trustpilotData.companyScore.score.stars}/128x24.png`}
                alt={'Trust Pilot stars'}
                critical={false}
              />
            </a>
          )}
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state: FsCore.State, props: any) => {
  const { sys } = props
  return {
    trustpilotData: getComponentById(state, sys.id)?.trustpilotData,
    ...props,
  }
})(CardFinder)
